import React from 'react';
import {
  Card,
  CardWrapper,
  CardTitle,
  CardValue,
  HeaderSubtitle,
  HeaderTitle,
  HeaderWrapper,
  SelectionMessage,
} from './styledComponents';
import FindPartNumber from './subcomponents/FindPartNumber';
import PartsDropdown from './subcomponents/PartsDropdown';

const Header = ({
  title,
  subtitle,
  selectionMessage,
  parts = [],
  cards = [],
  withLookup = false,
  feesNotAllowedMessage,
}) => {
  return (
    <>
      <HeaderWrapper>
        {title ? <HeaderTitle>{title}</HeaderTitle> : null}
        {subtitle ? <HeaderSubtitle>{subtitle}</HeaderSubtitle> : null}
        <CardWrapper>
          {parts.length ? (
            <Card>
              <CardTitle>Select Part Number:</CardTitle>
              <CardValue>
                <PartsDropdown parts={parts} />
              </CardValue>
            </Card>
          ) : null}
          {withLookup ? (
            <Card>
              <CardTitle htmlFor="part-number-field">Expected Part Number:</CardTitle>
              <CardValue>
                <FindPartNumber />
              </CardValue>
            </Card>
          ) : null}
          {cards
            ? cards.map((card) => (
                <Card className="warranty-header-card" key={card.title}>
                  <CardTitle>{card.title}</CardTitle>
                  <CardValue>{card.value}</CardValue>
                </Card>
              ))
            : null}
        </CardWrapper>
        {feesNotAllowedMessage ? (
          <SelectionMessage>{feesNotAllowedMessage}</SelectionMessage>
        ) : null}
      </HeaderWrapper>
      {selectionMessage ? <SelectionMessage>{selectionMessage}</SelectionMessage> : null}
    </>
  );
};

export default Header;
